// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z5HZpOgC{font-family:Inter}.Z5HZpOgC *{font-family:Inter !important}`, "",{"version":3,"sources":["webpack://./src/fsd/shared/ui/pagination/CustomPagination/CustomPagination.module.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CACA,YACE,4BAAA","sourcesContent":[".pagination {\n  font-family: Inter;\n  * {\n    font-family: Inter !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `Z5HZpOgC`
};
export default ___CSS_LOADER_EXPORT___;
